import Swiper, { Pagination, Autoplay } from 'swiper';
Swiper.use([Pagination, Autoplay]);
import * as balanceText from 'Lib/balanceText.js';

export namespace ContentAndMedia {
	let setupContentAndMedia = () => {

		let contentAndMedias = document.querySelectorAll('.content-and-media');

		//For Each Hero Slider Loop through and setup swiper
		contentAndMedias.forEach((candm, index) => {
			candm.classList.add(`content-and-media--${index}`);
			let swiperSlides = candm.querySelectorAll('.swiper-slide');
			let hasYoutubeVideos = candm.querySelectorAll('.js-content-and-media-video');

			if(candm.classList.contains('js-content-and-media')) {
				const swiper = new Swiper(`.content-and-media--${index}`, {
					slidesPerView: 1,

					// If we need pagination
					pagination: {
						el: `.content-and-media--${index} .swiper-pagination`,
						clickable: true
					},

					on: {
						slideChange: function () {
							if(hasYoutubeVideos.length) {
								let otherSlides = this.slides.filter((slide, index) => index !== this.activeIndex);

								otherSlides.forEach((slide) => {
									let playLink = slide.querySelector('.js-content-and-media-video');
									let iframeEl = slide.querySelector('iframe');
									if (iframeEl) {
										iframeEl.setAttribute('src', '');
										playLink.classList.remove('state-faded');
										iframeEl.setAttribute('src', `https://www.youtube.com/embed/${slide.getAttribute('data-youtubeId')}?enablejsapi=1&mute=1&rel=0&origin=${window.location.protocol + "//" + window.location.hostname}`);
									}
								})
							}
						},
						init: function () {
							balanceText();
						},
					},
				});
			}


			if(hasYoutubeVideos.length) {
				swiperSlides.forEach((slide, index) => {
					if(slide.getAttribute('data-youtubeId')) {
						let playLink = slide.querySelector('.js-content-and-media-video');
						playLink.addEventListener("click", function(e) {
							let iframeSrc = slide.querySelector('iframe').getAttribute('src');
							playLink.classList.add('state-faded');
							slide.querySelector('iframe').setAttribute('src', `${iframeSrc}&autoplay=1&rel=0`);
							e.preventDefault();
						});
					}
				});
			}
		});


	}


	export const init = () => {
		setupContentAndMedia();
	}
}


document.addEventListener('DOMContentLoaded', ContentAndMedia.init);
